<template>
  <div class="container">
    <v-app-view id="Witcher" :data="appArray[0]" />
    <v-app-view id="Dazzle" style="margin-top: 100px;" :data="appArray[1]" />
    <v-app-view id="Pugna" style="margin-top: 100px;" :data="appArray[2]" />
    <v-app-view id="Shadowdemon" style="margin-top: 100px;" :data="appArray[3]" />
    <v-app-view id="Winterwyvern" style="margin-top: 100px;" :data="appArray[4]" />
    <div id="location">
      <label>Shandong, China</label>
    </div>
    <div id="copyright">
      <label>Copyright &copy; 2020 Haharsw</label>
    </div>
  </div>
</template>

<script>
import PaintingAppView from '@/components/PaintingAppView.vue'

export default {
  name: 'PaintingApps',
  components: {
    "v-app-view": PaintingAppView
  },
  data() {
    return {
      appArray: [
        {
          key: 1,
          appTitle: 'Artlist - Masterpiece Theater',
          appIcon: require('@/assets/PaintingApps/Artlist/ArtlistAppIcon.jpg'),
          appDescription: 'Featured 200 classic, world-famous paintings, click to view high-definition picture, with a variety of filter functions to meet your visual feast.',
          appScreenShots: [
            require('@/assets/PaintingApps/Artlist/ArtlistPicture1.jpg'),
            require('@/assets/PaintingApps/Artlist/ArtlistPicture2.jpg'),
            require('@/assets/PaintingApps/Artlist/ArtlistPicture3.jpg')
          ]
        },
        {
          key: 2,
          appTitle: 'Paintings of Van Gogh',
          appIcon: require('@/assets/PaintingApps/vanGogh/vanGoghAppIcon.jpg'),
          appDescription: 'Featured collection of 543 Vincent van Gogh paintings, the app has a built-in convenient and diversified way of viewing pictures, click to view high-resolution images.',
          appScreenShots: [
            require('@/assets/PaintingApps/vanGogh/vanGoghPainting1.jpg'),
            require('@/assets/PaintingApps/vanGogh/vanGoghPainting2.jpg'),
            require('@/assets/PaintingApps/vanGogh/vanGoghPainting3.jpg')
          ]
        },
        {
          key: 3,
          appTitle: 'Paintings of Monet',
          appIcon: require('@/assets/PaintingApps/Monet/MonetAppIcon.jpg'),
          appDescription: 'Featured collection of 657 Claude Monet paintings, the app has a built-in convenient and diversified way of viewing pictures, click to view high-resolution images.',
          appScreenShots: [
            require('@/assets/PaintingApps/Monet/MonetPainting1.jpg'),
            require('@/assets/PaintingApps/Monet/MonetPainting2.jpg'),
            require('@/assets/PaintingApps/Monet/MonetPainting3.jpg')
          ]
        },
        {
          key: 4,
          appTitle: 'Paintings of Raphael',
          appIcon: require('@/assets/PaintingApps/Raphael/RaphaelAppIcon.jpg'),
          appDescription: 'Featured collection of 200 Raphael paintings, the app has a built-in convenient and diversified way of viewing pictures, click to view high-resolution images.',
          appScreenShots: [
            require('@/assets/PaintingApps/Raphael/RaphaelPicture1.jpg'),
            require('@/assets/PaintingApps/Raphael/RaphaelPicture2.jpg'),
            require('@/assets/PaintingApps/Raphael/RaphaelPicture3.jpg')
          ]
        },
        {
          key: 5,
          appTitle: 'Paintings of Bruegel',
          appIcon: require('@/assets/PaintingApps/Bruegel/BruegelAppIcon.jpg'),
          appDescription: 'Featured collection of 92 Bruegel Pieter the Elder paintings, the app has a built-in convenient and diversified way of viewing pictures, click to view high-resolution images.',
          appScreenShots: [
            require('@/assets/PaintingApps/Bruegel/BruegelPicture1.jpg'),
            require('@/assets/PaintingApps/Bruegel/BruegelPicture2.jpg'),
            require('@/assets/PaintingApps/Bruegel/BruegelPicture3.jpg')
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.container {
  text-align: center;
}
#location {
  font-weight: normal;
  font-size: 16px;
  margin-top: 60px;
  margin-bottom: 10px;
}
#copyright {
  font-weight: normal;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 40px;
}
</style>
